// @ts-nocheck

export const localeCodes =  [
  "es",
  "en"
]
export const localeLoaders = {
  es: [
    {
      key: "locale_index_46ts_09d5bc42",
      load: () => import("#nuxt-i18n/09d5bc42" /* webpackChunkName: "locale_index_46ts_09d5bc42" */),
      cache: true
    }
  ],
  en: [
    {
      key: "locale_index_46ts_5d6d0ce4",
      load: () => import("#nuxt-i18n/5d6d0ce4" /* webpackChunkName: "locale_index_46ts_5d6d0ce4" */),
      cache: true
    }
  ]
}
export const vueI18nConfigs = [
  () => import("#nuxt-i18n/d6af1e26" /* webpackChunkName: "config_i18n_46config_46ts_d6af1e26" */)
]
export const normalizedLocales = [
  {
    code: "es",
    name: "Español",
    language: undefined,
    domains: [],
    defaultForDomains: []
  },
  {
    code: "en",
    name: "English",
    language: undefined,
    domains: [],
    defaultForDomains: []
  }
]

